// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__15WV5","text":"SelectPayment_text__vxgfP","title":"SelectPayment_title__3SV2e","btn":"SelectPayment_btn__34QAp"};